import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'components'


@Injectable()
export class AppAuthGuard implements CanActivate {

  private gFormsAppletUrl: string;

  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isLogged: boolean;
    let path = route.routeConfig.path;
    isLogged = this.authService.isLoggedIn();
    if (path === 'home') {
      if (isLogged) {
        return isLogged;
      } else {
        this.router.navigate(['/login']);
      }
    } else if (path === 'login' || path === '') {
      if (isLogged) {
        this.router.navigate(['/home']);
      } else {
        return !isLogged;
      }
    }
  }

}
